import { CompanySettings } from '__generated__/GQL';
import { InvoiceFormSchema } from 'features/Work/form/invoiceForm.schema';
import { QuoteFormSchema } from 'features/Work/form/quoteForm.schema';

import formatLateMaxDaysValue from '../formatLateMaxDaysValue';

export const formatSharedBaseValues = (
  invoiceOrQuote: InvoiceFormSchema | QuoteFormSchema,
  settings?: CompanySettings,
) => ({
  lateFeePercentage:
    settings?.invoicingDefaultLateFeeFloatPercentage ??
    invoiceOrQuote.lateFeePercentage,
  lateMaxDays:
    formatLateMaxDaysValue(settings, invoiceOrQuote.startAt) ??
    invoiceOrQuote.lateMaxDays,
});

export const formatSharedSettingsValues = (
  invoiceOrQuoteSettings:
    | InvoiceFormSchema['settings']
    | QuoteFormSchema['settings'],
  settings?: CompanySettings,
) => ({
  issuerEmail:
    settings?.invoicingDefaultIssuerEmail ?? invoiceOrQuoteSettings.issuerEmail,
  legalMentions: settings?.invoicingDefaultCustomLegalMentions
    ? [settings.invoicingDefaultCustomLegalMentions]
    : invoiceOrQuoteSettings.legalMentions,
});
